<template>
  <v-container
    fluid
    class="rounded-lg elevation-3 pa-0"
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: var(--color-bg);
    "
  >
    <h3
      class="font-weight-light"
      style="color: var(--color-text)"
    >
      {{ title }}
    </h3>
    <v-progress-circular
      :size="50"
      color="var(--color-primary)"
      indeterminate
    />
  </v-container>
</template>

<script>
export default {
  name: "KDiagramLoadingContainer",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
